import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import FieldDropdownV2 from 'src/components/FormComponents/FieldDropdownV2'
import { Field } from '../../../../../components/FormComponents/Field'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import { actions as receivementActions } from '../../../ReceivementState'
import { useDispatch } from 'react-redux'
import Suffix from 'src/features/receivement/components/Suffix'
import { updateBatchCount } from 'src/services/receivement/divergenceService'
import { formatNumber } from 'src/utils/formatNumber'
import Submit from '../Components/Submit'
import { Fieldset } from './Fieldset'
import { Form } from './Form'
import * as S from './FormRecountKg.styles'
import { schema } from './schema'
import InformationField from '../../../components/InformationField'

const FormRecountKg = ({ batchId, batchDueDate, badge, product, onSuccess, onFailure }) => {
  const { control, handleSubmit, setFocus, watch, formState: { isSubmitting }, reset, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      tipoAvarias: 'NENHUM',
      quantidadeAvarias: 0,
    },
  })

  const [isDueDateExpired, setDueDateExpired] = useState(false)

  useEffect(() => {
    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0)
    if (batchDueDate) {
      const expired = batchDueDate < currentDate
      if (expired) {
        setValue('tipoAvarias', 'VENCIDO')
      }
      setDueDateExpired(expired)
    } else {
      setDueDateExpired(false)
    }
  }, [batchDueDate])

  const [damageSelected, setDamageSelected] = useState(true)
  const [disabledByProduct, setDisabledByProduct] = useState(true)

  const dispatch = useDispatch()

  const tiposAvaria = ['NENHUM', 'DANO']

  const weight = watch('weight')

  useEffect(() => {
    if (isDueDateExpired) {
      setValue('quantidadeAvarias', weight)
    }
  }, [weight])

  const onSubmit = async (data) => {
    const total = data.weight
    const result = await updateBatchCount(
      badge,
      batchId,
      total,
      data.tipoAvarias,
      data.quantidadeAvarias
    )
    reset()

    if (result.isOk) {
      onSuccess()
    } else {
      onFailure(result?.data?.message || 'Falha ao atualizar a contagem do lote!')
    }
  }

  const enterKeyCode = 13
  const tabKeyCode = 9

  const handleOnKeyDown = (event, nextField) => {
    if ([enterKeyCode, tabKeyCode].includes(event.keyCode) && !event.shiftKey) {
      event.preventDefault()
      setFocus(nextField)
    }
  }

  const onSuccessValidateBarcode = () => {
    setDisabledByProduct(false)
    setTimeout(() => setFocus('weight'), 100)
  }

  const handleOnKeyDownBarcode = (event) => {
    if ([enterKeyCode, tabKeyCode].includes(event.keyCode) && !event.shiftKey) {
      event.preventDefault()

      const idModel = product?.id_modelo
      const value = event.target.value
      const payload = { barcode: value, idModel , onSuccess: onSuccessValidateBarcode }

      if (value && idModel) {
        dispatch(receivementActions.validateProductBarcode(payload))
      }
    }
  }

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Fieldset>
          <Field
            labelText={`Bipe produto: ${product?.descricao_produto}`}
            name="barcode"
            control={control}
            type="text"
            onKeyDown={(e) => handleOnKeyDownBarcode(e)}
          />
        </Fieldset>
        <S.FieldsetKg>
          <Suffix suffix={'Kg'}>
            <S.Field
              as={FieldV2}
              control={control}
              type="text"
              labelText="Pesagem em quilos"
              name="weight"
              onInput={formatNumber}
              placeholder="0,000"
              onKeyDown={(e) => handleOnKeyDown(e, "tipoAvarias")}
              disabled={disabledByProduct}
            />
          </Suffix>
        </S.FieldsetKg>
        <Fieldset>
          {isDueDateExpired ? (
            <InformationField
              title='Tipo avaria'
              tooltipTitleMessage='Atenção: Lote vencido!'
              tooltipTitleAlertColor='#FF0000'
              info='VENCIDO'
              tooltipInfoMessage='Atenção: Lote vencido!'
              testId='automatic-due-date-damage-test-id'
            />
          ) : (
            <S.Field
              as={FieldDropdownV2}
              control={control}
              onKeyDown={(e) => handleOnKeyDown(e, "quantidadeAvarias")}
              labelText="Tipo avaria"
              type="text"
              name="tipoAvarias"
              options={tiposAvaria.map((v) => ({ value: v, label: v }))}
              onChange={(event) => {
                if (event.target.value === "NENHUM") {
                  setDamageSelected(true);
                  setValue("quantidadeAvarias", '0');
                  return;
                }
                setDamageSelected(false);
              }}
              disabled={disabledByProduct}
            />
          )}
          <Suffix suffix={'Kg'}>
            <S.Field
              as={FieldV2}
              control={control}
              type="text"
              labelText="Qtd. avarias"
              name="quantidadeAvarias"
              onInput={formatNumber}
              placeholder="0,000"
              readOnly={damageSelected || isDueDateExpired}
              disabled={disabledByProduct}
            />
          </Suffix>
        </Fieldset>
        <S.ButtonWrapper>
        <Submit
          textWhenEnabled="Incluir"
          textWhenDisabled="Salvando..."
          disabled={isSubmitting}
        />
        </S.ButtonWrapper>
      </Form>
    </>
  )
}

export { FormRecountKg }
